<template>
    <v-container style="padding-top: 70px;">
        <div v-if="showcargando == true" id="cargando" wire:loading class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center ">
            <div class=" loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4 "></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <v-row class="ma-1 ">
            <v-card width="100%" class="mx-2">
                <Menu></Menu>
            </v-card>
        </v-row>
    </v-container>
</template>
<script>
    import { mapGetters, mapState, mapMutations } from 'vuex';
    import Menu from '@/components/pages/Contraloria/MenuRecuperaciones/MenuRecup.vue';
    export default {
        title() {
            return this.$route.meta.title
        },
        components: {
            Menu,
            DataTable,
        },
        data() {
            return {
                showcargando: true,
            }
        },
        computed: {
            ...mapState(['permission', 'domain']),
            ...mapGetters(['getUser', 'THEME_STATE'])
        },
        async mounted() {
            this.showcargando = false;
        }
    }
</script>